import { Inject, Injectable, Optional } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { OpenWindowProvider, YattaExternalLink, isYattaExternalLanguageSpecificLinkUrl, isYattaExternalLink } from '@platform-frontend/util';
import { ExternalLink, LinkRenderer, isExternalLinkObject } from 'ngx-transloco-markup';
import { LinkRendererService } from './link-renderer.service';

@Injectable()
export class ExternalLinkRenderer implements LinkRenderer<ExternalLink | YattaExternalLink> {
  constructor(
    private linkRendererService: LinkRendererService,
    @Optional() @Inject(OpenWindowProvider) private openWindowProvider: string | null,
    private translocoService: TranslocoService
  ) {}

  supports(link: unknown): link is ExternalLink | YattaExternalLink {
    // Override TranslocoMarkup default external link renderer:
    return isExternalLinkObject(link) || isYattaExternalLink(link);
  }

  render(link: ExternalLink | YattaExternalLink, targetElement: HTMLAnchorElement): void {
    targetElement.setAttribute('href', isYattaExternalLanguageSpecificLinkUrl(link.url) ? link.url(this.translocoService.getActiveLang()) : link.url);
    targetElement.setAttribute('target', link.target ?? '_self');
    if (link.target === '_blank' && this.openWindowProvider) {
      targetElement.setAttribute('onclick', `${this.openWindowProvider}('${link.url}'); event.preventDefault()`);
    }
    if (isYattaExternalLink(link)) {
      if (link.id) {
        targetElement.setAttribute('id', link.id);
      }
      this.linkRendererService.renderLinkBase(link, targetElement);
    }
  }
}
